import { Component, h, Host, Prop } from '@stencil/core';

/**
 * @slot icon - Used to render an icon element or similar before the description text
 * @slot action - Descriptive name of the action to be taken
 */

@Component({
  tag: 'anchor-action-description',
  styleUrl: 'action-description.scss',
  shadow: true,
})
export class ActionDescription {

  /**
   * Controls whether or not the icon slot should be shown
   */
  @Prop({ reflect: true, mutable: true }) showIcon?: boolean = true;
  
  render() {
    return (
      <Host>
        <p class={{
          "action-description": true,
          "show-icon": this.showIcon
          }}>
          <slot name="icon"></slot>
          <slot name="action">Name of Action</slot>
        </p>
      </Host>
    );
  }
}
